import Styled from "styled-components";


export default Styled.div`
div.Place__Card{
    width: 301px;
 height: 252px;
background: #1B203A;
box-shadow: 0px 6.02px 18.06px #252948;
border-radius: 12.04px;
padding:25px;
margin-bottom:20px;
margin-left:30px;
margin-right:30px;
}

div.Place__sign{
    font-family: 'Poppins';
    flex:1;
font-style: normal;
font-weight: 400;
font-size: 8.5694px;
line-height: 13px;
color: rgba(255, 255, 255, 0.3);
}

div.Place__head {
 display:flex;
}

div.Place__id{

font-family: 'Poppins';
font-style: normal;
font-weight: 500;
font-size: 10.7117px;
line-height: 16px;
color: rgba(255, 255, 255, 0.7);

}

div.Place_state {
    font-family: 'Poppins';
font-style: normal;
font-weight: 400;
font-size: 8.5694px;
line-height: 13px;

color: rgba(255, 255, 255, 0.3);

}

div.Place{
    font-family: 'Poppins';
font-style: normal;
font-weight: 500;
font-size: 10.7117px;
line-height: 16px;

color: rgba(255, 255, 255, 0.7);

}

div.Place_icon {
    display:flex;
    align-items: center;
    justify-content:center;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 5.69061px;
    width:18.21px;
    height:17.64px;
}

div.pickup__location {
display:flex;
}

div.pickup__title{
    font-family: 'Poppins';
font-style: normal;
font-weight: 500;
font-size: 8.5694px;
line-height: 13px;
color: rgba(255, 255, 255, 0.7);
margin-bottom:3px;

}

div.pickup__place{

font-family: 'Poppins';
font-style: normal;
font-weight: 500;
font-size: 8.5694px;
line-height: 13px;
color: rgba(255, 255, 255, 0.3);
}

div.pickup__container{
    margin-left:10px;
}
`